import get from 'lodash/get'

export const fieldTools = ({
  form,
  register,
  errors,
  labelOverride,
  values
}) => (name, options) => {
  const nameInDotNotation = `${form}.${name}`
  const nameInBracketNotation = `${form}[${name}]`
  const { isDisabled, isReadOnly, isRequired, hasAsterisk } = {
    hasAsterisk: false, isReadOnly: false, isRequired: false, ...options
  }

  return {
    errorId: `${name}_error`,
    formParent: form,
    hasAsterisk,
    isDisabled,
    isInvalid: !!get(errors, nameInDotNotation),
    isReadOnly,
    isRequired,
    key: name,
    labelOverride,
    name: nameInBracketNotation,
    nameInDotNotation,
    register,
    value: get(values, nameInDotNotation)
  }
}
